<template>
  <v-dialog
    content-class="overflow-visible boilerplate-dialog"
    v-model="visible"
    width="90vw"
    :fullscreen="isModalFullscreen"
  >
    <component :is="currentComponent"></component>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import RequestDialog from '@/pages/eDispatch/requestDetails/RequestsDialog';
import PropertyDialog from '@/pages/hypervision/propertyDetail/PropertyDialog';

const { mapGetters, mapActions } = createNamespacedHelpers('boilerplate');
export default {
  name: 'CustomBoilerplateModal',
  components: {
    RequestDialog,
    PropertyDialog,
  },
  computed: {
    ...mapGetters(['isModalOpen', 'isOpen', 'isModalFullscreen']),
    visible: {
      get() {
        return this.isModalOpen;
      },
      set() {
        this.setModalOpened({ component: null });
      },
    },
    currentComponent() {
      const route = this.$route.name;
      const selected = this.isOpen.find((item) => item.route === route);
      return selected ? selected.component : null;
    },
  },
  methods: {
    ...mapActions(['setModalOpened']),
  },
};
</script>

<style>
.boilerplate-dialog {
  max-height: unset !important;
}
</style>
